module.exports = __webpack_public_path__ + "img/Question.c5bd1c8d.svg";